<template>
    <el-card class="fitness-edit">
        <div class="fitness-title">
            <el-tooltip class="margin: 4px" effect="dark" :content="$t('tooltip.back')" placement="bottom">
                <el-button type="primary" icon="iconfont icon-fitness-chehuisekuai" circle @click="back" />
            </el-tooltip>
            {{ $t('Staff.Employee_details') }}
        </div>
        <el-form
            ref="form"
            :model="form"
            label-width="120px"
            v-loading="loading"
            label-suffix=":"
            v-if="form"
        >
            <el-row type="flex" class="row-bg" justify="start">
                <el-col :span="8">
                    <el-form-item prop="jobNum" :label="$t('Staff.job_number')" >{{ form.jobNum }}</el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="nickname" :label="$t('Staff.nickname')" >{{ form.nickname }}</el-form-item>
                </el-col>
                <img :src="form.avatar" height="64" class="missing" style="padding: 0 50px;">
            </el-row>

            <el-row type="flex" class="row-bg" justify="start">
                <el-col :span="8">
                    <el-form-item prop="account" :label="$t('Staff.login_count')">{{ form.account }}</el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('Staff.password')">••••••</el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="start">
                <el-col :span="8">
                    <el-form-item :label="$t('Staff.actual_name')">{{ form.name }}</el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('Common.gender')" prop="gender">{{ form.gender }}</el-form-item>
                </el-col>
            </el-row>
            <el-form-item prop="storeIds" :label="$t('Common.store')">
                <div
                    v-if="form.stores"
                    :key="index"
                    v-for="(item, index) in form.stores"
                    style="display:inline-block;"
                >
                <span>{{item.name}}{{form.stores[index+1] ? '、' : ''}}</span>
                </div>
            </el-form-item>
            <el-row type="flex" class="row-bg" justify="start">
                <el-col :span="8">
                    <el-form-item
                        :label="$t('Common.phone_phone')"
                        prop="phone"
                    >{{ form.phone }}</el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item
                        :label="$t('Common.birthday')"
                    >{{ form.birthday }}</el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="start">
                <el-col :span="8">
                    <el-form-item :label="$t('Common.wechat')">{{ form.wechat }}</el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Email">{{ form.email }}</el-form-item>
                </el-col>
                <el-form-item :label="$t('Common.phone_phone')" prop="phone">{{ form.phone }}</el-form-item>
            </el-row>
            <el-form-item :label="$t('Staff.synopsis')">{{ form.description }}</el-form-item>
            <el-form-item :label="$t('Staff.Employee_photo')" prop="albums">
                <div
                    v-if="form.albums"
                    :key="index"
                    v-for="(item, index) in form.albums"
                    style="display:inline-block;">
                    <img @click="showImg(item)" :src="item" height="80px" class="mr-6">
                </div>
            </el-form-item>
            <el-form-item
                class="staff-show-coach"
                :label="$t('Staff.Show_style_coach')"
            >{{ form.showOnApp ? $t('Common.yes') : $t('Common.no') }}</el-form-item>
            <div style="border-top:1px solid #ccc; margin: 20px 0 20px 0px;"></div>

            <el-row type="flex" class="row-bg" justify="start">
                <el-col :span="8">
                    <el-form-item prop="jobStatus" :label="$t('Staff.Incumbency')">{{ form.jobStatus }}</el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('Staff.entry_time')" prop="workedAt">{{ form.workedAt }}</el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('Staff.resignation_time')" prop="leftAt">{{ form.leftAt }}</el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="start">
                <el-col :span="8">
                    <el-form-item prop="level" :label="$t('Staff.Staff_rank')">{{ form.level }}</el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="bankAccount" :label="$t('Staff.Bank_card_number')">{{ form.bankAccount }}</el-form-item>
                </el-col>
                <el-form-item prop="bankName" :label="$t('Staff.opening_bank')">{{ form.bankName }}</el-form-item>
            </el-row>
            <div style="border-top:1px solid #ccc; margin: 10px 0 20px 0px;"></div>
            <el-row type="flex" class="row-bg" justify="start">
                <el-col :span="8">
                    <el-form-item prop="idNum" :label="$t('Sell.identity_number')">
                        {{ form.idNum }}
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="address" :label="$t('Staff.current_residence')">{{ form.address }}</el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="start">
                <el-col :span="8">
                    <el-form-item prop="school" :label="$t('Staff.school_graduation')">{{ form.school }}</el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="major" :label="$t('Staff.major')">{{ form.major }}</el-form-item>
                </el-col>
                <el-form-item prop="graduatedAt" :label="$t('Staff.GraduationDate')">{{ form.graduatedAt }}</el-form-item>
            </el-row>
            <el-row type="flex" class="row-bg" justify="start">
                <el-col :span="8">
                    <el-form-item prop="education" :label="$t('Staff.education')">{{ form.education }}</el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="birthplace" :label="$t('Staff.nativeplace')">{{ form.birthplace }}</el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="nation" :label="$t('Client.Add.nation')">{{ form.nation }}</el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="start">
                <el-col :span="8">
                    <el-form-item prop="marriage" :label="$t('Common.marrystatus')">{{ form.marriage }}</el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="children" :label="$t('Client.Add.child_situation')">{{ form.children }}</el-form-item>
                </el-col>
            </el-row>
            <el-form-item prop="roles" :label="$t('Staff.role')">
                <div v-if="form.roles" :key="index" v-for="(item, index) in form.roles" style="display:inline-block;" >
                    <span>{{item.name}}{{form.roles[index+1] ? '、' : ''}}</span>
                </div>
            </el-form-item>
            <el-form-item prop="remark" :label="$t('Common.remark')">{{ form.remark }}</el-form-item>
        </el-form>
    </el-card>
</template>

<script>
import { Row, Col } from 'element-ui';

export default {
    components: {
        ElRow: Row,
        ElCol: Col,
    },
    data() {
        return {
            loading: false,
            form: null,
        };
    },
    created() {
        if (this.$route.params.id) this.fetchData();
    },
    methods: {
        fetchData() {
            this.loading = true;
            API.get(`staff/${this.$route.params.id}`)
                .then(res => {
                    this.form = res;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        showImg(item) {
            this.img = item;
            this.isShowImg = true;
            this.index = this.form.albums.findIndex(el => el === item);
        },
        back() {
            this.$router.back();
        },
    },
};
</script>
<style lang="scss">
</style>
